const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://circularideablender.com/api/',
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID || 'G-V2X2MVE8XF',
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://circularideablender.com',
  apiKey: process.env.REACT_APP_API_KEY || 'YOUR_DEFAULT_API_KEY_HERE', // Provide a default or handle its absence
};

export default config;
